import React from 'react';
import './ContactCTA.css';

const ContactCTA = () => {
  return (
    <section className="contact-cta" id="contact">
      <div className="contact-cta__inner">
        <div className="contact-cta__divider" />
      </div>
    </section>
  );
};

export default ContactCTA;


